var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.875 1.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.198 7.725c0-3.576-2.898-6.475-6.474-6.475C4.15 1.25 1.25 4.149 1.25 7.725c.001 3.576 2.9 6.475 6.474 6.475 3.576 0 6.474-2.9 6.474-6.475zm1.25 0c0 1.908-.693 3.652-1.839 5l2.458 2.458c.244.244.244.64 0 .884-.244.244-.64.244-.884 0l-2.458-2.458A8.155 8.155 0 0 1 7.724 15.45C3.459 15.45 0 11.992 0 7.725 0 3.459 3.458 0 7.724 0c4.267.001 7.724 3.459 7.724 7.725z"
  }))));
};
export default SvgSearch;